<template>
	<nav
		class="site_header"
		:class="{'scrolled': isScrolled}"
		ref="site_header"
		@mouseover="show = true"
		@mouseleave="show = false"
	>
		<div class="mobile_menu_nav container">
			<a
				href='/'
				class="site_header-brand"
				data-aos="fade-right"
				data-aos-duration="750"
				data-aos-offset="50"
				data-aos-once="true"
			>
				<!-- <img
					:src="parsedGlobalSettings.general.logo ? parsedGlobalSettings.general.logo : logo"
					alt="Duco"
				/> -->

				<animated-logo :scrolled="isScrolled"></animated-logo>

			</a>

			<div></div>

			<div class='right'>
				<!-- <div
					class="search"
					@click="toggleSearch"
				>
					<img
						:src='searchIcon'
						alt='Search Icon'
					>
				</div> -->
				<!-- <close-button
					v-else
					@click.native="toggleSearch"
				></close-button> -->
				<span
					data-aos="fade-left"
					data-aos-duration="750"
					data-aos-offset="50"
					data-aos-once="true"
				>
					<menu-button
						@click.native="toggleMobileMenu()"
						:label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
						:type="this.$store.state.mobile_menu ? 'close' : 'open'"
					></menu-button>

				</span>

			</div>
		</div>
		<!-- <transition name="bounce">
			<div
				class="mobile_menu_nav container scrolled "
				v-if="isScrolled"
			>
				<a
					href='/'
					class="site_header-brand"
				><img
						:src="parsedGlobalSettings.general.logo ? parsedGlobalSettings.general.logo : logo"
						alt="Duco"
					/></a>

				<div></div>

				<div class='right'>
					<menu-button
						@click.native="toggleMobileMenu()"
						:label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
						:type="this.$store.state.mobile_menu ? 'close' : 'open'"
					></menu-button>
				</div>

			</div>
		</transition> -->

		<mobile-menu
			:is-showing="this.$store.state.mobile_menu"
			:current-id="Number(currentId)"
			:menu-data="parsedMobileMenu"
			:global-settings="parsedGlobalSettings"
			:class="{'alert_open': this.$store.state.alert_bar_closed === false}"
		>
		</mobile-menu>

	</nav>
</template>

<script>
// import axios from 'axios';
// import MenuItem from '../vue/MenuItem.vue';
// import SecondaryMenuItem from '../vue/SecondaryMenuItem.vue';
import MobileMenu from '../vue/MobileMenu.vue';
import Search from '../../images/search.svg';
import Close from '../../images/close.svg';
// import CloseButton from './CloseButton.vue';
// import PrimaryButton from './PrimaryButton.vue';
import MenuButton from './MenuButton.vue';
// import LoadingAnimation from './LoadingAnimation.vue';
import AnimatedLogo from './AnimatedLogo.vue';

export default {
	data() {
		return {
			searchToggled: false,
			topScrollThreshold: 100,
			isScrolled: false,
			window: {
				width: 0,
				height: 0,
			},
			mobileMenuVisible: false,
			show: false,
			showSearch: false,
			showSearchMob: false,
			search: Search,
			close: Close,
			searchIcon: Search,
		};
	},

	props: {
		logo: {},
		language_switcher: {},
		login_link: {},
		currentId: {},
		current_page: {},
		global_settings: {},
		menu: {},
		sec_menu: {},
		mobile_menu: {},
		locale: {},
	},

	computed: {
		parsedMenu() {
			if (this.menu) {
				return JSON.parse(this.menu);
			} else {
				return null;
			}
		},

		parsedSecondaryMenu() {
			if (this.sec_menu) {
				return JSON.parse(this.sec_menu);
			} else {
				return null;
			}
		},

		parsedMobileMenu() {
			if (this.mobile_menu) {
				return JSON.parse(this.mobile_menu);
			} else {
				return null;
			}
		},

		featuredPostsParsed() {
			if (this.featured_posts) {
				return JSON.parse(this.featured_posts);
			} else {
				return null;
			}
		},

		parsedGlobalSettings() {
			if (this.global_settings) {
				return JSON.parse(this.global_settings);
			} else {
				return null;
			}
		},

		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},
	},

	watch: {
		searchToggled() {
			this.$nextTick(() => {
				this.focusInput();
			});
		},
	},

	methods: {
		toggleSearch() {
			this.searchToggled = !this.searchToggled;
			this.show = false;
		},

		focusInput() {
			if (this.$refs['search']) {
				this.$refs['search'].focus();
			}
		},

		toggleMobileMenu() {
			this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
		},

		localeParse(url) {
			if (this.locale != 'en_au') {
				const localeUpdate = new URL(url);
				return '/' + this.locale + localeUpdate.pathname;
			} else {
				return url;
			}
		},

		localeParseSimple(url) {
			if (this.locale != 'en_au') {
				return '/' + this.locale + url;
			} else {
				return url;
			}
		},

		didScroll() {
			var elementTarget = document.querySelector('.site_header');
			this.isScrolled = window.scrollY > elementTarget.offsetHeight + 100;
			this.searchToggled = false;
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('live-in-sa.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		closeOnEscape() {
			let the = this;
			document.onkeydown = function (evt) {
				evt = evt || window.event;
				var isEscape = false;
				if ('key' in evt) {
					isEscape = evt.key === 'Escape' || evt.key === 'Esc';
				} else {
					isEscape = evt.keyCode === 27;
				}
				if (isEscape) {
					the.showSearch = false;
					the.showSearchMob = false;
				}
			};
		},

		onTouchStart(event) {
			// Prevent propagation to avoid triggering the onClickOutside immediately
			event.stopPropagation();
		},
		onClickOutside(event) {
			if (
				this.$refs.container &&
				!this.$refs.container.contains(event.target)
			) {
				// Touch event happened outside of the container
				// Perform your desired function here
				this.performFunction();
			}
		},
		performFunction() {
			let the = this;
			// Your function implementation here
			console.log('Touch event happened outside of the container');

			if (the.searchToggled) {
				this.toggleSearch();
			}
		},
	},

	components: {
		// MenuItem,
		// SecondaryMenuItem,
		MobileMenu,
		// CloseButton,
		// PrimaryButton,
		MenuButton,
		// LoadingAnimation,
		AnimatedLogo,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
		this.$store.commit('toggleMobileMenu', false);
	},
	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
		this.closeOnEscape();
		document.addEventListener('touchstart', this.onClickOutside);
		document.addEventListener('mousedown', this.onClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('touchstart', this.onClickOutside);
		document.removeEventListener('mousedown', this.onClickOutside);
	},
	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
		this.$store.commit('toggleMobileMenu', false);
	},
	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_header {
	background: var(--black);
	position: fixed;
	width: 100%;
	z-index: var(--z-index-top);
	border-bottom: var(--border);
	height: 150px;
	display: flex;
	align-items: center;
	transition: 0.2s ease all;
	top: 0;

	@media (max-width: $mobile) {
		height: 100px;
	}

	&.scrolled {
		/* position: fixed;
		width: 100%;
		border-bottom: var(--border); */
		transition: 0.2s ease all;
		height: 50px;
		top: 0;
	}

	> .container {
		display: grid;
		grid-template-columns: 180px 1fr 180px;
		justify-content: space-between;
		align-items: center;

		@media (max-width: $mobile) {
			grid-template-columns: 180px 1fr auto;
		}

		.center {
			display: flex;

			&.center-right {
				justify-content: flex-end;
			}

			ul {
				list-style: none;
				padding: 0;
				margin: 0;
				display: flex;
				flex-direction: row;
				// column-gap: var(--spacer) * 2;
				justify-content: flex-end;
				align-items: center;
				grid-column: span 3;

				> li {
					// margin-right: calc(var(--spacer) * 1);

					&:last-of-type {
						margin-right: 0;
					}

					a {
						color: var(--live-blue);
						text-decoration: none;
						font-weight: 400;
						transition: 0.2s ease all;
						border-bottom: 1px solid transparent;
						padding-bottom: 10px;
						margin-left: 0;

						&:hover {
							border-bottom: 2px solid var(--live-blue);
							transition: 0.2s ease all;
						}
					}

					&.selected {
						a {
							border-bottom: 2px solid var(--live-blue);
							transition: 0.2s ease all;
						}
					}
				}

				> a {
					margin-left: calc(var(--spacer) * 2);
				}
			}
		}

		.right {
			display: flex;
			justify-content: flex-end;
			gap: 16px;
			.search {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 40px;
				height: 40px;

				&:hover {
					cursor: pointer;
				}
			}
		}
	}

	&-brand {
		display: flex;

		img {
			width: 100%;
		}
	}

	.mobile_menu {
		width: 100%;
		padding: 0;
		padding: 0;
		background: white;
		height: calc(100vh - 57px);
		position: absolute;
		top: 40px;
		left: 0;
		display: flex;
		flex-direction: column;

		li {
			.menu_cta {
				margin-left: 20px;
				margin-top: 20px;
			}
		}
	}

	.menu_banner {
		width: 100%;
		border-bottom: 1px solid #ccc;
		padding: 10px 20px;
		margin-bottom: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;

		a {
			color: var(--live-blue);
			font-size: 14px;
			line-height: 16.8px;
			font-weight: 600;

			@media (max-width: $mobile) {
				font-size: 18px;
				line-height: 20px;
				align-items: center;
			}

			&:hover {
				cursor: pointer;
			}
		}
	}

	.mobile_menu_nav {
		width: 100%;
		/* padding-top: 50px;
		padding-bottom: 50px; */
		position: relative;
		z-index: 60;
		/* border-bottom: var(--border); */
		padding: 0 40px;
		/* @media (max-width: 1280px) {
			border-bottom: var(--border);
		} */

		&.scrolled {
			/* position: fixed; */
			/* border-bottom: var(--border); */
			/* width: 100%;
			top: 0; */

			/* @media (max-width: $mobile-xl) {
				width: calc(100% - 32px);
			} */
		}
	}
}

.menu_toggle {
	&:hover {
		cursor: pointer;
	}

	svg {
		path {
			fill: var(--duco-blue);
		}
	}
}

.search-outer-wrapper {
	width: 100%;
	position: fixed;
	top: 56px;
	z-index: 10;

	@media (max-width: $mobile) {
		top: 56px;
	}
}

.search-outer {
	@media (max-width: 767px) {
		top: 56px !important;
	}

	.searchbox {
		.inner-wrap {
			.col {
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(100%);
	// opacity: 0;
}

.slide-fade-vert-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-vert-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-vert-enter, .slide-fade-vert-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-20px);
	opacity: 0;
}

.bounce-enter-active {
	animation: bounce-in 0.15s;
}

.bounce-leave-active {
	animation: bounce-in 0.15s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(-100px);
		opacity: 0;
	}
	// 50% {
	// 	transform: translateY(30px);
	// 	opacity: 1;
	// }
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue